'use client';

import {Link} from '@tanstack/react-router';
import RcPagination, {PaginationProps as RcPaginationProps} from 'rc-pagination';
import ruLocale from 'rc-pagination/lib/locale/ru_RU';

import {ChevronLeft, ChevronRight} from '../../icons';
import {PaginationButtonSide} from './PaginationButtonSide';

interface PaginationProps {
  pagination: {
    total: number;
    page: number;
    take: number;
  };
}

export const Pagination = ({pagination}: PaginationProps) => {
  const itemRender: RcPaginationProps['itemRender'] = (page, type, element) => {
    if (type === 'prev') {
      return (
        <PaginationButtonSide
          to="."
          search={(prev: {page?: number}) =>
            page !== 1 ? {...prev, page} : {...prev, page: undefined}
          }
          disabled={page === 1}
          preload="intent"
        >
          <ChevronLeft className="size-4" />
          <span>Назад</span>
        </PaginationButtonSide>
      );
    }

    if (type === 'next') {
      return (
        <PaginationButtonSide
          to="."
          search={(prev: {page?: number}) => ({...prev, page})}
          preload="intent"
        >
          <span>Вперед</span>
          <ChevronRight className="size-4" />
        </PaginationButtonSide>
      );
    }

    if (type === 'page') {
      return (
        <Link
          className="flex size-10 items-center justify-center rounded-md border border-[transparent] text-sm transition-colors hover:border-border-primary hover:bg-bg-secondary [&.active]:border-border-primary [&.active]:bg-bg-secondary"
          to="."
          search={(prev: {page?: number}) =>
            page !== 1 ? {...prev, page} : {...prev, page: undefined}
          }
          activeOptions={{exact: true}}
          preload="intent"
        >
          {page}
        </Link>
      );
    }

    if (type === 'jump-next') {
      return (
        <button
          className="flex size-10 items-center justify-center rounded-md border border-[transparent] text-sm transition-colors hover:border-border-primary hover:bg-bg-secondary"
          type="button"
        >
          ...
        </button>
      );
    }

    return element;
  };

  if (pagination.total <= pagination.take) {
    return null;
  }

  return (
    <RcPagination
      className="mt-auto flex justify-center gap-1"
      defaultCurrent={pagination.page}
      total={pagination.total}
      pageSize={pagination.take}
      itemRender={itemRender}
      locale={ruLocale}
    />
  );
};
